const MARKET_PRICE_VALUE_HANDLE = "MARKET_PRICE_VALUE_HANDLE";
const USDT_PRICE_VALUE_HANDLE = "USDT_PRICE_VALUE_HANDLE";
const COIN_PRICE_VALUE_HANDLE = "COIN_PRICE_VALUE_HANDLE";
const PAGE_NAME = "PAGE_NAME";

export {
  MARKET_PRICE_VALUE_HANDLE,
  USDT_PRICE_VALUE_HANDLE,
  COIN_PRICE_VALUE_HANDLE,
  PAGE_NAME,
};
